/* eslint-disable */
import fetch from "./fetchGo";
const boxliteUrl = process.env.NODE_ENV == 'production' ? 'https://popvip-go-miniapp.paquapp.com/' : 'https://testpopvip-go.paquapp.com/'
const popGlobalUrl = process.env.NODE_ENV == 'production' ? ' https://beta-qrcodeweb-api.popmart.com/' :  'https://beta-qrcodeweb-api.popmart.com/'
export default {
  getWxURLScheme(data){
    return fetch({
      method: "POST",
      url: '/v2/wechat_open_api/generate_scheme',
      data: data
    })
  },
  getStoreVipTrans(params){
    return fetch({
      method: "GET",
      url: '/v2/sg/order/snapshot',
      params
    })
  },
  getPointShot(params){
    return fetch({
      method: "GET",
      url: '/v2/points_store/order_snapshot',
      params,
    })
  },
  getGiftCard(params){
    return fetch({
      method: "GET",
      url: '/v2/gift_card/snapshot',
      params,
    })
  },
  getTicketShot(params){
    return fetch({
      method: "GET",
      url: '/v2/pop_show/order_snapshot',
      params,
    })
  },
  getBoxliteNormalTrans(params){
    return fetch({
      method: "GET",
      url: boxliteUrl + 'boxlite/orderserver/api/order/snapshotList',
      params,
      headers: {
        identity_code: params.identity_code
      }
    })
  },
  getBoxliteOrderDetail(params){
    return fetch({
      method: "GET",
      url: boxliteUrl + 'boxlite/orderserver/api/order/snapshot',
      params,
      headers: {
        identity_code: params.identity_code
      }
    })
  },
  getGlobalIP(){
    return fetch({
      method: "GET",
      url: popGlobalUrl + 'common/v1/common/get_country_by_ip',
    })
  }
};
